/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 03.06.17.
 */

import JsonSchema from "./JsonSchema";
import UiSchema from "./UiSchema";
import t from "./trans";

/**
 * Class for handling JsonSchema and corresponding UISchema
 * Field reference:
 *  a) JSON Schema corresponds to an array:
 *      "*", ":{name}", "[{index}]" - Selects array item
 *  b) JSON Schema corresponds to an object:
 *      {fieldName} - Selects property with the name {fieldName}
 *
 *
 */
class Schema extends JsonSchema {
    /**
     * From object JSON Schema creates array JSON Schema where array items are specified objects.
     * @param {JsonSchema} jsonSchema JSON Schema
     * @returns {JsonSchema} Corresponding array JSON Schema
     */
    static createArrayJsonSchema(jsonSchema) {
        if (!jsonSchema) return null;
        let arraySchema = {
            type: "array"
        };
        if (jsonSchema.title) arraySchema.title = jsonSchema.title;
        if (jsonSchema.titlePl) {
            arraySchema.title = jsonSchema.titlePl;
            arraySchema.titlePl = jsonSchema.titlePl;
        }
        arraySchema.items = jsonSchema;
        return arraySchema;
    }

    /**
     * Creates new Schema object
     * @public
     * @param {JsonSchema} jsonSchema JSON Schema corresponding to this object
     * @param {JsonUiSchema} uiSchema UI Schema corresponding to this object
     * @param {String} fieldName Field name corresponding to this object
     */
    constructor(jsonSchema, uiSchema, fieldName) {
        super(jsonSchema, fieldName);
        this.uiSchema = new UiSchema(uiSchema, fieldName);
    }

    getTitle() {
        let title = t(this.getUiSchemaElement("title"));
        if (title) return title;
        return super.getTitle();
    }

    getTitlePl() {
        let title = t(this.getUiSchemaElement("titlePl"));
        if (title) return title;
        return super.getTitlePl();
    }

    /**
     * Returns UI Schema object corresponding to this schema.
     * @returns {UiSchema}
     */
    getUiSchemaObject() {
        return this.uiSchema;
    }

    /**
     * @public
     * @returns {JsonUiSchema}
     */
    getUiSchema() {
        return this.uiSchema.getUiSchema();
    }

    /**
     * Return current element field list
     * @public
     * @returns {String[]}
     */
    getFieldList() {
        let fields = this.getUiSchemaElement("order");
        if (fields) return fields;
        return super.getFieldList();
    }

    getOrder() {
        return this.getUiSchemaElement("order");
    }

    getSort() {
        return this.getUiSchemaElement("sort");
    }

    getResource() {
        return this.getUiSchemaElement("resource");
    }

    getValidator() {
        return this.getUiSchemaElement("validator");
    }

    getRequired() {
        let required = super.getRequired();
        if (required) return required;
        return this.getUiSchemaElement("required");
    }

    /**
     * Returns data form the record corresponding to specified field name
     * @param data Record data
     * @param field Field name, can be hierarhical.
     * @returns {*} Field value from record data
     */
    getFieldValue(data, field) {
        let fieldParts = field.split("/");
        let currentData = data;
        for (let f of fieldParts) {
            if (currentData && currentData[f]) currentData = currentData[f];
            else return null;
        }
        return currentData;
    }

    createNewSchema(currentSchema, field) {
        let currentUiSchema = this.uiSchema.field(field);
        return new Schema(currentSchema, currentUiSchema.getUiSchema(), field);
    }

    /**
     * @public
     * @param element
     * @returns {*}
     */
    getSchemaElement(element) {
        let value = this.uiSchema.getSchemaElement(element);
        if (value) return value;
        if (this.jsonSchema && this.jsonSchema[element]) return this.jsonSchema[element];
        return null;
    }

    getUiSchemaElement(element) {
        return this.uiSchema.getSchemaElement(element);
    }
}

export default Schema;
